import React, { useEffect, useState } from "react"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { Link, withRouter } from "react-router-dom"
import { defineMessages, FormattedMessage, injectIntl } from "react-intl"
import StandardList from "../../common/listing/list.component.jsx"
import SideBar from "../../common/layout/sidebar.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import Icon from "../../common/icon/icon.component.jsx"
import IntlProps from "../../state/helpers/IntlProps"
import { RouteComponentProps } from "react-router"
import templateService from "../../state/template/TemplateService"
import { isError } from "../../state/helpers/Error"
import Template from "../../state/template/Template"
import { TYPE_SMS } from "../../state/conversation/ConversationThreadTypes"

const messages = defineMessages({
    "default_name": {
        id: "templates.default_template_name",
        defaultMessage: "Default template",
    }
})

type PathParamsType = {
    templateKey: string,
}

// Your component own properties
type PropsType = RouteComponentProps<PathParamsType> & IntlProps & {
    templateKey: string,
}

const SMSTemplatesListing = (props: PropsType) => {

    const [smsTemplateListing, setSMSTemplateListing] = useState({
        rows: [[<></>]],
        headers: [<></>, <></>, ""],
        loading: true,
    })

    useEffect(() => {
        SideBar.activateMenu("sales-tools")
        refreshSearch()
    }, [])

    const refreshSearch = () => {
        templateService.findAllTemplates(TYPE_SMS, props.match.params.templateKey).then(res => {
            if (!isError(res)) {
                if (res.length == 0) {
                    templateService.findByTemplateKey(props.match.params.templateKey).then(res => {
                        if (!isError(res)) {
                            setSMSTemplateListing({
                                ...smsTemplateListing,
                                headers: headers(),
                                rows: [row(res)],
                                loading: false,
                            })
                        }
                    })
                } else {
                    setSMSTemplateListing({
                        ...smsTemplateListing,
                        headers: res.length > 0 ? headers() : [<></>, <></>, ""],
                        rows: res.map(q => row(q)),
                        loading: false,
                    })
                }
            }
        })
    }

    const headers = () => {
        return [
            <FormattedMessage
                key="templates.list.headers.name_label"
                id="templates.list.headers.name_label"
                defaultMessage="Name"
            />,
            <FormattedMessage
                key="templates.list.headers.language_label"
                id="templates.list.headers.status_label"
                defaultMessage="Status"
            />,
            "",
        ]
    }

    const row = (item: Template) => {
        return [
            <Link key={0}
                to={"/settings/editSMSTemplatesById/" + item.getId()}>{item.getName() ||
                props.intl.formatMessage(messages["default_name"])}
            </Link>,
            <span key={1}>{getStatusBadge(item.getStatus())}</span>,
            <div key={2}>
                <Link to={"/settings/editSMSTemplatesById/" + item.getId()} className="btn btn-sm btn-outline-primary">
                    <FormattedMessage
                        id="templates.list.headers.edit_sections_btn"
                        defaultMessage="Edit content"
                    />
                </Link>
                {item.getStatus() !== "default" &&
                    <button onClick={setDefault(item.getId())} className="btn btn-sm btn-outline-primary ml-2">
                        <FormattedMessage
                            id="templates.list.headers.set_default_btn"
                            defaultMessage="Default"
                        />
                    </button>
                }
            </div>,
        ]
    }

    const getStatusBadge = (status) => {
        switch (status) {
        case "enabled":
            return <div>
                <div className="badge badge-primary">
                    <FormattedMessage
                        id="templates.list.status.enabled_label"
                        defaultMessage="Enabled"
                    />
                </div>
            </div>
        case "disabled":
            return <div>
                <div className="badge badge-secondary">
                    <FormattedMessage
                        id="templates.list.status.disabled_label"
                        defaultMessage="Disabled"
                    />
                </div>
            </div>
        case "default":
            return <div>
                <div className="badge badge-info">
                    <FormattedMessage
                        id="templates.list.status.default_label"
                        defaultMessage="Default"
                    />
                </div>
            </div>
        default:
            return ""
        }
    }

    const setDefault = (templateId) => {
        return function (e) {
            e.preventDefault()
            AppContext.getApiClient().patch("/templates/" + templateId + "/default").then(() => {
                setTimeout(() => {
                    refreshSearch()
                }, 500)
            })
        }.bind(this)
    }
    let list = <StandardList
        className="row pt-3"
        headers={smsTemplateListing.headers}
        rows={smsTemplateListing.rows}
    />
    if (smsTemplateListing.loading) {
        list = <LoadingSpinner/>
    }

    return (
        <div>
            <div className="row ui-has-modules py-1">
                <div className="col-12 ui-module mb-0">
                    <div className="row mb-0 justify-content-end">
                        <div className="col-9">
                            <Link to={"/branding"} className="btn btn-light">
                                <Icon value={"chevron-left"}/>
                                <FormattedMessage
                                    id="templates.list.back_btn"
                                    defaultMessage="Back to branding"
                                />
                            </Link>
                        </div>
                        <div className="col-3 text-align-right ">
                            <Link to={"/settings/editSMSTemplates/" + props.match.params.templateKey + "/new"}
                                className="btn btn-primary">
                                <Icon value={"plus-circle"}/>
                                <FormattedMessage
                                    id="templates.sms.list.create_template_btn"
                                    defaultMessage="Add template"
                                />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            {list}
        </div>
    )
}

export default withRouter(injectIntl(SMSTemplatesListing))


// WEBPACK FOOTER //
// ./src/settings/sms/SMSTemplatesListing.tsx